import { initialState } from './state';

export function push(state, error) {
  Object.assign(state, { stack: [...state.stack,  error] });
}
